import { useCallback, useState } from 'react';

const STORAGE_KEY = 'admin-agent-drawer-width';
export const DRAWER_MIN_WIDTH = 320;
export const DRAWER_DEFAULT_WIDTH = 420;
const DRAWER_MAX_WIDTH = 900;
/** Keeps the page content usable next to the drawer on narrower screens. */
const DRAWER_MAX_VIEWPORT_RATIO = 0.6;

export function clampDrawerWidth(width: number): number {
  const max = Math.min(DRAWER_MAX_WIDTH, Math.floor(window.innerWidth * DRAWER_MAX_VIEWPORT_RATIO));
  return Math.round(Math.min(Math.max(width, DRAWER_MIN_WIDTH), Math.max(max, DRAWER_MIN_WIDTH)));
}

function readStoredWidth(): number {
  try {
    const stored = Number(window.localStorage.getItem(STORAGE_KEY));
    return Number.isFinite(stored) && stored > 0 ? clampDrawerWidth(stored) : DRAWER_DEFAULT_WIDTH;
  } catch {
    return DRAWER_DEFAULT_WIDTH;
  }
}

/** Drawer width in px, clamped and remembered per browser (storage is best-effort). */
export function useDrawerWidth() {
  const [width, setWidthState] = useState(readStoredWidth);

  const setWidth = useCallback((next: number) => {
    setWidthState(clampDrawerWidth(next));
  }, []);

  const persist = useCallback((value: number) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, String(value));
    } catch {
      // storage unavailable: the width just won't be remembered
    }
  }, []);

  return { width, setWidth, persist };
}
